import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {TextTranslateWithLocaleModel} from '../views/models/textTranslateWithLocale.model';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TextTranslateService {
  records_Changed = new Subject<TextTranslateWithLocaleModel>();

  constructor(private httpClient: HttpClient) {

  }

  translateWithLocale(locale: string, engSourceText: string[]) {
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/translate_to/' + locale,
      {
        eng_source_descriptions: engSourceText,
        source_location: 'en'
      },
      {
        observe: 'body',
        responseType: 'json'
      }).pipe(tap(resp => {
      // console.log(resp);
    }));
  }
}
